import React, { useState } from "react";

const HolidayCalculator = () => {
  const [weeklyHours, setWeeklyHours] = useState("");
  const [holidayWeeks, setHolidayWeeks] = useState(5.6); // Default statutory entitlement
  const [dailyHours, setDailyHours] = useState(""); // For converting hours to days
  const [yearlyHours, setYearlyHours] = useState(null);
  const [holidayHours, setHolidayHours] = useState(null);
  const [holidayDays, setHolidayDays] = useState(null);

  const calculateHoliday = () => {
    if (!weeklyHours || isNaN(weeklyHours) || !dailyHours || isNaN(dailyHours)) {
      alert("Please enter valid numbers for weekly and daily hours!");
      return;
    }

    // Calculate yearly hours based on weekly hours
    const yearly = parseFloat(weeklyHours) * 46.4;

    // Calculate holiday hours entitlement
    const holidayRate = holidayWeeks / 46.4; // Adjusted rate
    const entitlementInHours = yearly * holidayRate;

    // Convert holiday hours into days
    const entitlementInDays = entitlementInHours / parseFloat(dailyHours);

    setYearlyHours(yearly.toFixed(2)); // Save yearly hours
    setHolidayHours(entitlementInHours.toFixed(2)); // Save holiday hours
    setHolidayDays(entitlementInDays.toFixed(2)); // Save holiday days
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-4 bg-white rounded shadow-md">
      <h1 className="text-xl font-bold text-gray-800">Holiday Entitlement Calculator (UK Standard)</h1>

      {/* Weekly Hours Input */}
      <div className="my-4">
        <label htmlFor="weeklyHours" className="block text-sm font-medium text-gray-700">
          Weekly Hours Worked
        </label>
        <input
          type="number"
          id="weeklyHours"
          value={weeklyHours}
          onChange={(e) => setWeeklyHours(e.target.value)}
          placeholder="Enter your weekly hours"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>

      {/* Holiday Weeks Input */}
      <div className="my-4">
        <label htmlFor="holidayWeeks" className="block text-sm font-medium text-gray-700">
          Weeks of Holiday Entitlement (Default: 5.6 weeks)
        </label>
        <input
          type="number"
          id="holidayWeeks"
          value={holidayWeeks}
          onChange={(e) => setHolidayWeeks(e.target.value)}
          placeholder="Enter holiday entitlement in weeks"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>

      {/* Daily Hours Input */}
      <div className="my-4">
        <label htmlFor="dailyHours" className="block text-sm font-medium text-gray-700">
          Daily Working Hours
        </label>
        <input
          type="number"
          id="dailyHours"
          value={dailyHours}
          onChange={(e) => setDailyHours(e.target.value)}
          placeholder="Enter your daily working hours"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>

      {/* Calculate Button */}
      <button
        onClick={calculateHoliday}
        className="mt-4 w-full bg-indigo-600 text-white py-2 px-4 rounded-md shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        Calculate Holiday Entitlement
      </button>

      {/* Yearly Hours Display */}
      {yearlyHours && (
        <div className="mt-4 p-4 border rounded bg-blue-50 text-blue-800">
          <p>
            <strong>Yearly Hours Worked:</strong> {yearlyHours} hours
          </p>
        </div>
      )}

      {/* Holiday Entitlement Display */}
      {holidayHours && holidayDays && (
        <div className="mt-4 p-4 border rounded bg-green-50 text-green-800">
          <p>
            <strong>Total Holiday Entitlement:</strong>
          </p>
          <ul className="list-disc list-inside">
            <li>{holidayHours} hours</li>
            <li>{holidayDays} days</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default HolidayCalculator;
